module.exports = __webpack_public_path__ + "6e8cc30d0459394d1b354fe292913564.svg";